import { Overlay } from 'radix-ui/dialog';

import './styles.css';

export function DialogOverlay() {
  return <Overlay className="DialogOverlay" />;
}
